import React from "react";
import { Table } from "antd";
import * as S from "../styles";
import { Installment } from "../types";
import { columns } from "./columns";
import { InstallmentOptionsTableProps } from "./types";

export const InstallmentOptionsTable = ({
  installmentOptions,
  onSelectOption,
  selectedRow,
}: InstallmentOptionsTableProps) => {
  return installmentOptions.length ? (
    <S.CommonSection>
      <S.SectionTitle>Simulação de parcelamento</S.SectionTitle>
      <Table<Installment>
        rowSelection={{
          type: "radio",
          selectedRowKeys: selectedRow?.quantidadeParcelas
            ? [selectedRow?.quantidadeParcelas]
            : [],
          onSelect: (selectedRow) => {
            onSelectOption(selectedRow);
          },
        }}
        columns={columns}
        pagination={false}
        scroll={{ y: 240 }}
        rowKey="quantidadeParcelas"
        dataSource={installmentOptions}
      />
    </S.CommonSection>
  ) : null;
};
